export default __webpack_public_path__ + "static/media/bridge-flow-2.32d12132.png";